import { Component, OnInit } from '@angular/core';
import { GenericService } from '../services/generic.service';
import {ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-generic-detail',
  templateUrl: './generic-detail.component.html',
  styleUrls: ['./generic-detail.component.css']
})
export class GenericDetailComponent implements OnInit {
  public theHtmlString ="";
  retItem: any;
  retItems: any;
  constructor(private genericService: GenericService, private route: ActivatedRoute) { 

  }

  ngOnInit() {

    this.route.params.subscribe( params => {console.log(params);
      this.LoadData(params.id);
    });


  }


  LoadData(id:any ) {
    
    this.genericService.getItem(id).subscribe((data) => {
      this.retItem = data;
      console.log(this.retItem);
        this.theHtmlString = this.retItem.html_content;
    }), 
    err => {
         console.log(err);
      }
  }
}
